<template>
  <v-chip
    depressed
    :dark="isSelected"
    :color="isSelected ? 'primary' : ''"
    @click="$emit('onClick')"
  >
    <v-avatar v-if="stockImage">
      <img :src="stockImage" />
    </v-avatar>

    <slot name="text"></slot>
  </v-chip>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'stock', 'option', 'isSelected', 'level'],
  computed: {
    ...mapGetters({}),
    stockImage() {
      var stock = this.stock.find(el => {
        return this.level == 0 && el[1] && el[1].includes(this.option + '/')
      })
      if (stock) return stock[7]
      return null
    },
    hasStock() {
      if (!this.stock) {
        return false
      }

      var option = this.stock.find(el => {
        return el[1] == this.option
      })
      if (option) {
        try {
          return parseInt(option[2]) > 0
        } catch (error) {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductOptionItem.vue